module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Big-Little-Lies-S2.41a0548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Big-Little-Lies-S2.jpg
// module id = +WOy
// module chunks = 0